const KUI_FORM_VALIDATION_MSG_CLIENT = 'kui-form-validation-msg-client';
const KUI_FORM_VALIDATION_MSG_SERVER = 'kui-form-validation-msg-server';
const KUI_FORM_VALIDATION_INPUT = 'kui-form-validation-input';

const showFormFieldError = (form, error) => {
    if (!form && !error) {
        return;
    }

    const input = form.querySelector(`[${KUI_FORM_VALIDATION_INPUT}]`);
    const errorMsgClient = form.querySelector(
        `[${KUI_FORM_VALIDATION_MSG_CLIENT}]`
    );
    const errorMsgServer = form.querySelector(
        `[${KUI_FORM_VALIDATION_MSG_SERVER}]`
    );

    // Remove server-side errors from DOM
    if (errorMsgServer) {
        errorMsgServer.style.display = 'none';
    }

    if (errorMsgClient) {
        errorMsgClient.id = KUI_FORM_VALIDATION_MSG_CLIENT;
        errorMsgClient.classList.add(
            'kui-form-field-error-msg',
            'kui-form-field-error-msg--variant-block',
            'kui-util-type-body-2'
        );
        errorMsgClient.textContent = error;
    }

    if (input) {
        input.setAttribute('aria-describedby', KUI_FORM_VALIDATION_MSG_CLIENT);
        input.setAttribute('aria-invalid', 'true');
    }
};

export {showFormFieldError};
